import Link from 'next/link';

import { CategoryMegaMenuEmptyStateProps } from './models';

import { ArrowLeft2 } from 'iconsax-react';

export const CategoryMegaMenuEmptyState = ({ categoryName, categoryHref, isDark, onNavigate }: CategoryMegaMenuEmptyStateProps) => (
    <div className='flex flex-1 flex-col items-center justify-center py-8'>
        <Link
            href={categoryHref}
            onClick={onNavigate}
            className={`inline-flex items-center gap-1 text-sm font-bold no-underline transition-opacity hover:opacity-80 ${
                isDark ? 'text-white' : 'text-primary'
            }`}>
            مشاهده محصولات {categoryName}
            <ArrowLeft2 size={14} color='currentColor' />
        </Link>
    </div>
);
